module.exports = __webpack_public_path__ + "static/media/Home Page_website-03.251a22d4.png";